import { ICart, IPortin } from "@features/cart/ICart";

interface IUsageResponse {
    description: string;
    value: string;
    displayOrder: number;
}

export interface IOfferResponse {
    catalogOfferCode: string;
    catalogTariffPlanCode: string;
    description: string;
    displayOrder: number;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
    usages: IUsageResponse[];
}

export interface ICartOfferResponse {
    baseOffer: IOfferResponse;
    offerId: number;
    port?: IPortin;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
}

export interface ICartResponse {
    nbrAdditionalAllowedSubscriptions: number;
    offers: ICartOfferResponse[];
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
}

export const getResponseToState = (response: ICartResponse): ICart => ({
    nbrAdditionalAllowedSubscriptions: response.nbrAdditionalAllowedSubscriptions,
    offers: response.offers.map((offer) => ({
        baseOffer: {
            catalogTariffPlanCode: offer.baseOffer.catalogTariffPlanCode,
            catalogOfferCode: offer.baseOffer.catalogOfferCode,
            description: offer.baseOffer.description,
            displayOrder: offer.baseOffer.displayOrder,
            recurringChargeAmount: offer.baseOffer.recurringChargeAmount,
            upFrontChargeAmount: offer.baseOffer.upFrontChargeAmount,
            usages: offer.baseOffer.usages.map((usage) => ({
                description: usage.description,
                value: usage.value,
                displayOrder: usage.displayOrder,
            })),
        },
        offerId: offer.offerId,
        port: offer.port
            ? {
                  code: offer.port.code,
                  msisdn: offer.port.msisdn,
                  operator: offer.port.operator,
                  serviceType: offer.port.serviceType,
              }
            : undefined,
        recurringChargeAmount: offer.recurringChargeAmount,
        upFrontChargeAmount: offer.upFrontChargeAmount,
    })),
    recurringChargeAmount: response.recurringChargeAmount,
    upFrontChargeAmount: response.upFrontChargeAmount,
});
